export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_TAGS = 'tags';
export const SET_SHOW_COMISSAO = 'showComissao';

